import React from 'react';

const Loader = () => {
  return (
    <div className="spinner-container">
      <div className="spinner-ellipsis">
        <div />
        <div />
        <div />
        <div />
        <div />
      </div>
    </div>
  );
};

export default Loader;
